module.exports = __webpack_public_path__ + "img/IMG_9321_L_Wood.a1d74f75.jpg";